import { api } from '../utils/api'
import type { BusinessAssociation } from '../types/api'

export const getBusinessAssociations = async (userName: string) => {
  const response = await api.get<BusinessAssociation[]>(
    `/Ketenverbanden/${userName}`
  )
  return response.data
}

export const getBusinessAssociationNumber = async (userName: string) => {
  const response = await api.get<number>(
    `/Ketenverbanden/${userName}/administrationnumber`
  )
  return response.data
}
